var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "70", height: "70", viewBox: "0 0 70 70", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "cue/email.inline"
    ),
    React.createElement("path", { d: "M55 0H15C6.716 0 0 6.716 0 15v40c0 8.284 6.716 15 15 15h43v-5H15C9.477 65 5 60.523 5 55V15C5 9.477 9.477 5 15 5h40c5.523 0 10 4.477 10 10v28a7 7 0 0 1-7 7h-3V20h3v-5h-9v5.33a21 21 0 1 0 0 29.34V55h9c6.627 0 12-5.373 12-12V15c0-8.284-6.716-15-15-15zM34 50c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15a15 15 0 0 1-15 15z", fill: "#FFF", fillRule: "nonzero" })
  );
});